import React from 'react';
import {
  dowel_bodyweight_squat,
  dowel_standing_hip_hinge,
  ng_shoulder_width_lat_pull_down,
  dowel_standing_shoulder_press,
  db_front_foot_elevated_split_squat
} from 'utils/constants/assessments';
import MovementField from './MovementField';

export default function MovementList({
  dowelBodyweightSquat,
  dowelStandingShoulderPress,
  dowelStandingHipHinge,
  dbFrontFootElevatedSplitSquat,
  ngShoulderWidthLatPullDown,
  addToFilesToBeDeleted
}) {
  return (
    <div className="movement-list">
      <div>
        <MovementField
          title={dowel_bodyweight_squat.title}
          urlFieldName={`${dowelBodyweightSquat}.video.url`}
          sizeFieldName={`${dowelBodyweightSquat}.video.size`}
          ratingFieldName={`${dowelBodyweightSquat}.rating_measurement_unit`}
          dysfunctionFieldName={`${dowelBodyweightSquat}.dysfunction`}
          dysfunctions={dowel_bodyweight_squat.dysfunctions.map(
            (label, index) => {
              return {
                fieldName: `${dowelBodyweightSquat}.dysfunction.${index}`,
                label
              };
            }
          )}
          addToFilesToBeDeleted={addToFilesToBeDeleted}
        />

        <MovementField
          title={dowel_standing_hip_hinge.title}
          urlFieldName={`${dowelStandingHipHinge}.video.url`}
          sizeFieldName={`${dowelStandingHipHinge}.video.size`}
          ratingFieldName={`${dowelStandingHipHinge}.rating_measurement_unit`}
          dysfunctionFieldName={`${dowelStandingHipHinge}.dysfunction`}
          dysfunctions={dowel_standing_hip_hinge.dysfunctions.map(
            (label, index) => {
              return {
                fieldName: `${dowelStandingHipHinge}.dysfunction.${index}`,
                label
              };
            }
          )}
          addToFilesToBeDeleted={addToFilesToBeDeleted}
        />

        <MovementField
          title={ng_shoulder_width_lat_pull_down.title}
          urlFieldName={`${ngShoulderWidthLatPullDown}.video.url`}
          sizeFieldName={`${ngShoulderWidthLatPullDown}.video.size`}
          ratingFieldName={`${ngShoulderWidthLatPullDown}.rating_measurement_unit`}
          dysfunctionFieldName={`${ngShoulderWidthLatPullDown}.dysfunction`}
          dysfunctions={ng_shoulder_width_lat_pull_down.dysfunctions.map(
            (label, index) => {
              return {
                fieldName: `${ngShoulderWidthLatPullDown}.dysfunction.${index}`,
                label
              };
            }
          )}
          addToFilesToBeDeleted={addToFilesToBeDeleted}
        />
      </div>

      <div>
        <MovementField
          title={dowel_standing_shoulder_press.title}
          urlFieldName={`${dowelStandingShoulderPress}.video.url`}
          sizeFieldName={`${dowelStandingShoulderPress}.video.size`}
          ratingFieldName={`${dowelStandingShoulderPress}.rating_measurement_unit`}
          dysfunctionFieldName={`${dowelStandingShoulderPress}.dysfunction`}
          dysfunctions={dowel_standing_shoulder_press.dysfunctions.map(
            (label, index) => {
              return {
                fieldName: `${dowelStandingShoulderPress}.dysfunction.${index}`,
                label
              };
            }
          )}
          addToFilesToBeDeleted={addToFilesToBeDeleted}
        />

        <MovementField
          title={db_front_foot_elevated_split_squat.title}
          urlFieldName={`${dbFrontFootElevatedSplitSquat}.video.url`}
          sizeFieldName={`${dbFrontFootElevatedSplitSquat}.video.size`}
          ratingFieldName={`${dbFrontFootElevatedSplitSquat}.rating_measurement_unit`}
          dysfunctionFieldName={`${dbFrontFootElevatedSplitSquat}.dysfunction`}
          dysfunctions={db_front_foot_elevated_split_squat.dysfunctions.map(
            (label, index) => {
              return {
                fieldName: `${dbFrontFootElevatedSplitSquat}.dysfunction.${index}`,
                label
              };
            }
          )}
          addToFilesToBeDeleted={addToFilesToBeDeleted}
        />
      </div>
    </div>
  );
}
